<div class="month-container">
  <span class="legend"
    >Cerberus contains data from {{ months[0].month }}
    {{ months[0].year }} through {{ months[months.length - 1].month }}
    {{ months[months.length - 1].year }}. For more info please contact
    <a
      href="mailto:katia.gutierrez@astrazeneca.com?cc=roger.lobo@astrazeneca.com,rose.adibi@astrazeneca.com"
      >support</a
    >
  </span>
  <div
    class="month {{ month.selected ? 'selected' : '' }} {{
      isFirstOrLast(i) ? 'first-last' : ''
    }}"
    *ngFor="let month of months; let i = index"
    (click)="handleClick(month, i)"
  >
    <div class="month-card">
      <span class="month-label">{{ month.month }}</span>
      <span class="year-label">{{ month.year }}</span>
    </div>
  </div>
</div>
